import { Hub } from 'aws-amplify/utils';
import { isWeb } from './platform.js';
import { getAuthConfig } from './config.js';

class AuthHubManager {
    async startListening() {
        if (this.isListening) {
            return;
        }
        try {
            this.unsubscribe = Hub.listen('auth', (data)=>{
                const { payload } = data;
                this.listeners.forEach((callback)=>{
                    callback({
                        event: payload.event,
                        data: payload.data
                    });
                });
            });
            this.isListening = true;
        } catch (error) {
            console.error('Failed to start Hub events:', error);
            getAuthConfig().onError?.(error, {
                context: 'AuthHubManager',
                message: 'Failed to start Hub events'
            });
        }
    }
    stopListening() {
        if (this.unsubscribe) {
            this.unsubscribe();
            this.unsubscribe = undefined;
        }
        this.isListening = false;
    }
    addListener(callback) {
        this.listeners.add(callback);
        if (this.listeners.size === 1 && !this.isListening) {
            this.startListening();
        }
    }
    removeListener(callback) {
        this.listeners.delete(callback);
        if (this.listeners.size === 0 && this.isListening) {
            this.stopListening();
        }
    }
    clearListeners() {
        this.listeners.clear();
        this.stopListening();
    }
    checkOAuthCompletion() {
        if (!isWeb()) return false;
        const url = window.location.href;
        const urlParams = new URLSearchParams(window.location.search);
        const hasCode = urlParams.has('code');
        const hasError = urlParams.has('error');
        const isOAuthCallback = url.includes('oauth2/idpresponse') || hasCode || hasError;
        if (isOAuthCallback) {
            this.listeners.forEach((callback)=>{
                callback({
                    event: 'signInWithRedirect_complete',
                    data: {
                        url,
                        hasCode,
                        hasError
                    }
                });
            });
            return true;
        }
        return false;
    }
    constructor(){
        this.listeners = new Set();
        this.isListening = false;
    }
}
const authHubManager = new AuthHubManager();
const createAuthHubListener = (callback)=>{
    authHubManager.addListener(callback);
    return ()=>authHubManager.removeListener(callback);
};
const checkOAuthCompletion = ()=>{
    return authHubManager.checkOAuthCompletion();
};

export { AuthHubManager, authHubManager, checkOAuthCompletion, createAuthHubListener };
//# sourceMappingURL=hubEvents.js.map
